import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { axiosApi } from '../../utils/axiosApi'

const useGetAllDesignation = () => {
    const [allDesignationOptionsById, setAllDesignationOptionsById] = useState([])

    useEffect(() => {
        try {
            axiosApi(process.env.REACT_APP_BASE_URL + '/emp/getAllDesignation',{},"GET")
                .then((res) => {
                    const filterOptionById = (res?.data?.data)?.length > 0 && (res?.data?.data)?.map((itm) => {
                        return ({ value: itm._id, label: itm.empDesignation })
                    })

                    if (filterOptionById?.length > 0) {
                        setAllDesignationOptionsById(filterOptionById)
                    }
                })
                .catch((err) => {
                    console.log("Error", err)
                })
        } catch (error) {
            console.log("Error", error)
        }
    }, [])



    return {allDesignationOptionsById }
}

export default useGetAllDesignation